import React from "react";

const CustomCard = ({ title, value, label }) => {
  return (
    <div className="bg-gray-800 rounded-lg p-4 shadow-md hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 hover:bg-gray-700 animate-fade-in">
      <div className="mb-2">
        <h3 className="text-sm font-medium text-gray-300 animate-slide-in">
          {title}
        </h3>
      </div>
      <div className="text-2xl font-bold text-white animate-scale-in">
        {value}
      </div>
      <p className="text-xs text-gray-400 mt-1 animate-slide-in-delayed">
        {label}
      </p>
    </div>
  );
};

export default CustomCard;
